<template>
  <a
    :class="['link']"
    :href="value.href"
    :rel="rel"
    :target="target"
  >
    <slot />
  </a>
</template>

<script setup>
defineOptions({ inheritAttrs: false });

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
});
const isExternal = !props.value.href.startsWith('/');
const rel = isExternal ? 'noreferrer noopener' : undefined;
const target = isExternal ? '_blank' : undefined;
</script>

<style scoped lang="scss" type="text/scss">
  .link {
    color: $link-color;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
